import * as THREE from 'three';
//隧道的基本信息
export class Tunnel{
    constructor(tunnelInnerHeight, tunnelOuterWidth, tunnelOuterHeight, roadStakes, allRoadStakes){
        this.tunnelInnerHeight = tunnelInnerHeight;
        this.tunnelOuterHeight = tunnelOuterHeight;
        this.tunnelOuterWidth = tunnelOuterWidth;
        this.botCenterLine = new Array();
        this.startStake = roadStakes[0].stakeval;
        this.endStake = roadStakes[roadStakes.length - 1].stakeval;
        this.roadStakes = roadStakes;
        this.allRoadStakes = allRoadStakes;
        roadStakes.map(item=>{
          var center = new THREE.Vector3();
          center.copy(item.center);
          center.width = item.leftBaseWidth + item.rightBaseWidth;
          this.botCenterLine.push(center);
        });          
    }

}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/Tunnel.js